import { cloneElement } from "react"
import { UserProvider } from "./user"
import { BasketProvider } from "./basket"
import { StyleProvider } from "./style"
import { LoadingProvider } from "./loading"
import { SessionProvider } from "./session"

const providers = [
  <UserProvider />,
  <BasketProvider />,
  <StyleProvider />,
  <LoadingProvider />,
  <SessionProvider />,
]

export const Store = ({ children: initial }) =>
  providers.reduce((children, parent) => cloneElement(parent, { children }), initial)
